/**
 * Labstep
 *
 * @module core/MailTag
 * @desc Component to display a tag with mailto href
 */

import type React from 'react';
import type { IMailTagProps } from './types';

export const MailTag: React.FC<IMailTagProps> = ({ department }) => (
  <a
    href={`mailto:${department}@labstep.com`}
  >{`${department}@labstep.com`}</a>
);
